import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerEight from "../components/DashBoardLayerEight";
import WelcomeScreenLayer from "../components/WelcomeScreenLayer";
import { hasPermission } from "../services/auth";
import { useTranslation } from "../i18n/I18nContext";

const HomePageEight = () => {
  const { t } = useTranslation();
  // Profiles without 'dashboard.view' (see "Perfis e Permissões") land here
  // too — '/dashboard' is the default post-login route for everyone — so an
  // elaborate Welcome screen with quick links to what they *do* have access
  // to replaces the actual dashboard content instead of an access-denied wall.
  const canViewDashboard = hasPermission("dashboard.view");

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title={canViewDashboard ? "Dashboard" : t("welcome.breadcrumb.title")} />

        {canViewDashboard ? <DashBoardLayerEight /> : <WelcomeScreenLayer />}
      </MasterLayout>
    </>
  );
};

export default HomePageEight;
